import Keycloak from "keycloak-js";
import { useKeycloak } from "@react-keycloak/web";
import { loginKcUser } from "./services/axiosAPI";
// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
import { useNavigate } from "react-router-dom";

/* const keycloak = new Keycloak({
  url: "https://sso.ecoop.cloud",
  realm: "masterpiece",
  clientId: "ecoop-frontend",
});

export default keycloak; */

export const keycloak = new Keycloak({
  url: "https://sso.ecoop.cloud",

  realm: "masterpiece",
  clientId: "sit-frontend",
});

export const onKcEvent = (keycloak, event, err) => {
  if (event === "onAuthSuccess") {
    onKcToken({ refreshToken: keycloak.idTokenParsed, token: keycloak.token });
    //console.log("KC Auth userid", keycloak.token, keycloak.idTokenParsed);
  }
};

export const onKcToken = async ({ refreshToken, token }, setAuth) => {
  if (token && !localStorage.getItem("token")) {
    await loginKcUser(token);
    setAuth(true);
    //console.log("KC Token", token, refreshToken);
  }
};
